import { CodeBook, ExportTypeEnum, PagedResult } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils/apiUtils";

import { SaveResult } from "../../models";
import { Item, Group, ItemSearch } from "../../models/Faq";

const apiUrlPrefix: string = "faq";

export const getGroupById = async (id: number) => {
    return api.get(
        `${apiUrlPrefix}/group/${id}`
    ) as Promise<Group>
}

export const getGroupList = async () => {
    return api.get(
        `${apiUrlPrefix}/group`
    ) as Promise<Group[]>
}

export const getItemById = async (id: number) => {
    return api.get(
        `${apiUrlPrefix}/item/${id}`
    ) as Promise<Item>
}

export const searchItem = async (search: ItemSearch) => {
    return api.post(
        `${apiUrlPrefix}/search`,
        search
    ) as Promise<PagedResult<Item>>
}

export const getApplicationDisplayList = async () => {
    return api.get(
        `${apiUrlPrefix}/application-displays`
    ) as Promise<CodeBook[]>
}

export const saveGroup = async (group: Group) => {
    return api.put(
        `${apiUrlPrefix}/save-group`,
        group
    ) as Promise<SaveResult<Group>>
}

export const saveItem = async (item: Item) => {
    return api.put(
        `${apiUrlPrefix}/save-item`,
        item
    ) as Promise<SaveResult<Item>>
}

export const getFaqDocumentById = async (id: number) => {
    return api.download(
        `${apiUrlPrefix}/document/${id}`
    ) as Promise<any>
}

export const getFaqGroupListExport = async (type: ExportTypeEnum) => {
    return api.download(
        `${apiUrlPrefix}/group/export/${type}`,
        "post"
    ) as Promise<any>
}

export const getFaqItemListExport = async (search: ItemSearch, type: ExportTypeEnum) => {
    return api.download(
        `${apiUrlPrefix}/item/export/${type}`,
        "post",
        search
    ) as Promise<any>
}
